__turbopack_context__.v({
  "className": "red_hat_display_696231cd-module__2rbWlq__className",
});
